// === ./src/frontend/FrontEnd.js ===
import React from "react";
import { Box, useTheme } from "@mui/material";
import { useCustomTheme } from "../utils/useCustomTheme";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import HowItWorksSection from "./components/HowItWorksSection";
import FeaturesSection from "./components/FeaturesSection";
import StatsBar from "./components/StatsBar";
import PricingSection from "./components/PricingSection";
import TestimonialsSection from "./components/TestimonialsSection";
import CTASection from "./components/CTASection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import { TranslateContext } from "../context/TranslateContext";

const FrontEnd = () => {
  const theme = useTheme();
  const { lang } = React.useContext(TranslateContext);
  const { toggleColorMode, isDark } = useCustomTheme();

  return (
    <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
      <Navbar onToggleTheme={toggleColorMode} isDark={isDark} theme={theme} />
      <HeroSection theme={theme} />
      <HowItWorksSection theme={theme} />
      <FeaturesSection theme={theme} />
      <StatsBar theme={theme} />
      <PricingSection theme={theme} />
      <TestimonialsSection theme={theme} />
      <CTASection theme={theme} />
      <FAQSection theme={theme} />
      <Footer theme={theme} />
    </Box>
  );
};

export default FrontEnd;
